<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <app-modal-back></app-modal-back>
    </ion-buttons>
    <ion-title>Create a job</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="no-header">
  <mable-heading heading="h2">What type of job is it?</mable-heading>
  <div class="ion-margin-horizontal">
    <ion-item
      lines="none"
      class="default ion-margin-vertical"
      (click)="createRegularJob()"
      button
      detail
    >
      <ion-icon
        name="megaphone"
        class="ion-margin-end"
        slot="start"
      ></ion-icon>
      <div class="ion-margin-end">
        <h1 class="header-news-22-bold">Standard</h1>
        <p class="body-normal-16">Ongoing or one-off support starting in the next 3 days or more.</p>
      </div>
    </ion-item>
    <ion-item
      lines="none"
      class="default ion-margin-vertical"
      (click)="createFlexJob()"
      button
      detail
    >
      <ion-icon
        name="stopwatch"
        class="ion-margin-end"
        slot="start"
      ></ion-icon>
      <div class="ion-margin-end">
        <h1 class="header-news-22-bold">Last Minute</h1>
        <p class="body-normal-16">One-off support starting in the next 4 to 48 hours.</p>
      </div>
    </ion-item>
  </div>

  <div class="tile">
    <dashboard-feature-tile
      size="small"
      [bText]="'Differences in job types'"
      [toggle]="true"
    >
      <div class="content">
        <div class="block">
          <mable-heading
            heading="h5"
            color="orange-500"
            >Workers reply within</mable-heading
          >
          <div class="chip">
            <ion-chip
              color="grey-100"
              class="ion-margin-end"
            >
              <ion-label class="body-normal-16">Standard</ion-label>
            </ion-chip>
            <p class="body-semi-bold ion-color-grey-500">24 hours</p>
          </div>
          <div class="chip">
            <ion-chip
              color="grey-100"
              class="ion-margin-end"
            >
              <ion-label class="body-normal-16">Last Minute</ion-label>
            </ion-chip>
            <p class="body-semi-bold ion-color-grey-500">2 hours</p>
          </div>
        </div>
        <div class="block">
          <mable-heading
            heading="h5"
            color="orange-500"
            >Job post expires after</mable-heading
          >
          <div class="chip">
            <ion-chip
              color="grey-100"
              class="ion-margin-end"
            >
              <ion-label class="body-normal-16">Standard</ion-label>
            </ion-chip>
            <p class="body-semi-bold ion-color-grey-500">30 days</p>
          </div>
          <div class="chip">
            <ion-chip
              color="grey-100"
              class="ion-margin-end"
            >
              <ion-label class="body-normal-16">Last Minute</ion-label>
            </ion-chip>
            <p class="body-semi-bold ion-color-grey-500">2 days at most</p>
          </div>
        </div>
        <div class="block">
          <mable-heading
            heading="h5"
            color="orange-500"
            >Can search for workers and invite them to apply</mable-heading
          >
          <div class="chip">
            <ion-chip
              color="grey-100"
              class="ion-margin-end"
            >
              <ion-label class="body-normal-16">Standard</ion-label>
            </ion-chip>
            <p class="body-semi-bold ion-color-grey-500">Yes</p>
          </div>
          <div class="chip">
            <ion-chip
              color="grey-100"
              class="ion-margin-end"
            >
              <ion-label class="body-normal-16">Last Minute</ion-label>
            </ion-chip>
            <p class="body-semi-bold ion-color-grey-500">No</p>
          </div>
        </div>
        <div class="block">
          <mable-heading
            heading="h5"
            color="orange-500"
            >Maximum number of offers from workers</mable-heading
          >
          <div class="chip">
            <ion-chip
              color="grey-100"
              class="ion-margin-end"
            >
              <ion-label class="body-normal-16">Standard</ion-label>
            </ion-chip>
            <p class="body-semi-bold ion-color-grey-500">No limit</p>
          </div>
          <div class="chip">
            <ion-chip
              color="grey-100"
              class="ion-margin-end"
            >
              <ion-label class="body-normal-16">Last Minute</ion-label>
            </ion-chip>
            <p class="body-semi-bold ion-color-grey-500">5</p>
          </div>
        </div>
      </div>
    </dashboard-feature-tile>
  </div>
</ion-content>
